var map = {
	"./260.png": 790,
	"./332.png": 791,
	"./363.png": 792,
	"./365.png": 793,
	"./367.png": 794,
	"./370.png": 795,
	"./404.png": 796,
	"./406.png": 797,
	"./411.png": 798,
	"./413.png": 799,
	"./415.png": 800,
	"./action_point.png": 801,
	"./add.png": 802,
	"./add_point.png": 803,
	"./button_green.png": 804,
	"./button_green_hover.png": 805,
	"./button_green_pressed.png": 806,
	"./close.png": 807,
	"./close_hover.png": 808,
	"./copy_link.png": 809,
	"./copy_link.svg": 810,
	"./dagger.png": 811,
	"./dropdown.png": 812,
	"./flourish.png": 813,
	"./frame.png": 814,
	"./frame_bottom.png": 815,
	"./frame_bottom_gray.png": 816,
	"./frame_brown.png": 817,
	"./frame_corner_bottom_left.png": 818,
	"./frame_corner_bottom_left_gray.png": 819,
	"./frame_corner_bottom_right.png": 820,
	"./frame_corner_bottom_right_gray.png": 821,
	"./frame_corner_top_left.png": 822,
	"./frame_corner_top_left_gray.png": 823,
	"./frame_corner_top_right.png": 824,
	"./frame_corner_top_right_gray.png": 825,
	"./frame_fancy.png": 826,
	"./frame_left.png": 827,
	"./frame_left_gray.png": 828,
	"./frame_right.png": 829,
	"./frame_right_gray.png": 830,
	"./frame_top.png": 831,
	"./frame_top_gray.png": 832,
	"./haze.png": 833,
	"./import.png": 834,
	"./import.svg": 835,
	"./portrait_frame.png": 836,
	"./remove_point.png": 837,
	"./save.png": 838,
	"./scroll_down.png": 839,
	"./scroll_down_disabled.png": 840,
	"./scroll_down_hover.png": 841,
	"./scroll_down_pressed.png": 842,
	"./scroll_up.png": 843,
	"./scroll_up_disabled.png": 844,
	"./scroll_up_hover.png": 845,
	"./scroll_up_pressed.png": 846,
	"./scrollbar.png": 847,
	"./scrollbar_disabled.png": 848,
	"./scrollbar_hover.png": 849,
	"./scrollbar_test.png": 850,
	"./trash_can.png": 851,
	"./trash_can.svg": 852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 789;